import { defineEnum } from '@siclop/kstone-vue'

export enum ProjectStatus {
  Draft = 0,
  QuoteSent = 1,
  InProgress = 2,
  OnHold = 3,
  Completed = 4,
  Cancelled = 5,
  Invoiced = 6
}

export const useProjectStatusLabels = defineEnum({
  i18nPrefix: 'ksproject.enums.projectStatus',
  entries: {
    [ProjectStatus.Draft]: { key: 'draft', label: 'Brouillon', tagType: 'info' },
    [ProjectStatus.QuoteSent]: { key: 'quoteSent', label: 'Devis envoyé', tagType: 'warning' },
    [ProjectStatus.InProgress]: { key: 'inProgress', label: 'En cours', tagType: 'primary' },
    [ProjectStatus.OnHold]: { key: 'onHold', label: 'En pause', tagType: 'warning' },
    [ProjectStatus.Completed]: { key: 'completed', label: 'Terminé', tagType: 'success' },
    [ProjectStatus.Cancelled]: { key: 'cancelled', label: 'Annulé', tagType: 'danger' },
    [ProjectStatus.Invoiced]: { key: 'invoiced', label: 'Facturé', tagType: 'success' }
  }
})
